// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3gkmO","title":"AfterBackImages_title__3so5L","images":"AfterBackImages_images__godVK"};